var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.4 69.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #568da8;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.8,35l-19.7-22.2c-1-1.1-2.4-1.7-3.9-1.7h-18v-.6c0-5-4.1-9.1-9.1-9.1H10.4C5.4,1.4,1.3,5.5,1.3,10.5v44.3c0,3,2.4,5.4,5.4,5.4h14c1.1,4.8,5.5,8.5,10.6,8.5s9.5-3.6,10.6-8.5h52.6c1.1,4.8,5.5,8.5,10.6,8.5s9.5-3.6,10.6-8.5h2.1c2.9,0,5.2-2.3,5.2-5.2v-16.6c0-1.3-.5-2.5-1.3-3.4h.1ZM116.6,35.3h-23.4c-.5,0-.8-.4-.8-.8v-10.5c0-.5.4-.8.8-.8h12.5l10.8,12.2h0ZM10.4,5.4h60.6c2.8,0,5.1,2.3,5.1,5.1v30.8H5.3V10.5c0-2.8,2.3-5.1,5.1-5.1ZM31.4,64.7c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9,6.9,3.1,6.9,6.9-3.1,6.9-6.9,6.9ZM42.2,56.3c-.8-5.3-5.3-9.4-10.8-9.4s-10,4.1-10.8,9.4H6.8c-.8,0-1.4-.6-1.4-1.4v-9.5h70.8v10.9h-34ZM105.3,64.7c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9,6.9,3.1,6.9,6.9-3.1,6.9-6.9,6.9ZM117.9,56.3h-1.9c-.8-5.3-5.3-9.4-10.8-9.4s-10,4.1-10.8,9.4h-14.3V15.1h18c.3,0,.6.1.9.4l3.2,3.6h-9c-2.7,0-4.8,2.2-4.8,4.8v10.5c0,2.7,2.2,4.8,4.8,4.8h25.8v15.8c0,.6-.5,1.2-1.2,1.2h.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.8f3f9380153dd0401ec75cc85d095e08.svg";
export { ForwardRef as ReactComponent };